export default "__VITE_ASSET__BTaVCzHB__"